// extracted by mini-css-extract-plugin
module.exports = {"switchableModules":"switchable_switchableModules___Ve2P","containerUi":"switchable_containerUi__1Isd5"};